import { APP_NAME, ProcessingKey } from 'constants/rootConstants'
import { goTo } from 'route-history'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'
import { fetchGeoData } from './fetchGeoData'
import { getFacebookParams } from 'helpers/getFacebookParams'
import { subscriptionsApi } from 'api'
import {
  getMarketingTopicFromRawValue as getIntl2MarketingTopicFromRawValue,
  MARKETING_TOPIC_QUERY_PARAM,
  isAdaptiveMarketingTopic as isIntl2AdaptiveMarketingTopic,
} from 'cohorts/intl_2/constants/marketing-topic'
import {
  getMarketingTopicFromRawValue as getIntl2LwMarketingTopicFromRawValue,
  isAdaptiveMarketingTopic as isIntl2LwAdaptiveMarketingTopic,
} from 'cohorts/intl_2lw/constants/marketing-topic'
import {
  getMarketingTopicFromRawValue as getIntlD60MarketingTopicFromRawValue,
  isAdaptiveMarketingTopic as isIntlD60AdaptiveMarketingTopic,
} from 'cohorts/intl_d60/constants/marketing-topic'
import {
  getMarketingTopicFromRawValue as getIntlD70MarketingTopicFromRawValue,
  isAdaptiveMarketingTopic as isIntlD70AdaptiveMarketingTopic,
} from 'cohorts/intl_d70/constants/marketing-topic'
import { Cohort } from 'root-constants'

export const createLead = async (): Promise<void> => {
  useZustandStore.getState().startProcessing(ProcessingKey.CREATE_LEAD)

  const initialCohort = useZustandStore.getState().initialCohort
  const searchParams = new URLSearchParams(window.location.search)
  const language = useZustandSessionStore.getState().language
  const inputEmail = useZustandStore.getState().inputEmail
  const { fbp, fbc } = getFacebookParams()
  const isIntl2LwCohort =
    initialCohort === Cohort.INTL_2LW || initialCohort === Cohort.INTL_HLWN70
  const isIntlD60Cohort = initialCohort === Cohort.INTL_D60
  const isIntlD70Cohort = initialCohort === Cohort.INTL_D70
  const isIntl2Cohort =
    initialCohort === Cohort.INTL_2 ||
    isIntl2LwCohort ||
    isIntlD60Cohort ||
    isIntlD70Cohort ||
    initialCohort === Cohort.INTL_MW
  const marketingTopicRaw = isIntl2Cohort
    ? searchParams.get(MARKETING_TOPIC_QUERY_PARAM)
    : null
  const marketingTopic = isIntlD70Cohort
    ? getIntlD70MarketingTopicFromRawValue(marketingTopicRaw)
    : isIntlD60Cohort
      ? getIntlD60MarketingTopicFromRawValue(marketingTopicRaw)
      : isIntl2LwCohort
        ? getIntl2LwMarketingTopicFromRawValue(marketingTopicRaw)
        : getIntl2MarketingTopicFromRawValue(marketingTopicRaw)
  const isAdaptiveTopic = isIntlD70Cohort
    ? isIntlD70AdaptiveMarketingTopic(
        getIntlD70MarketingTopicFromRawValue(marketingTopicRaw),
      )
    : isIntlD60Cohort
      ? isIntlD60AdaptiveMarketingTopic(
          getIntlD60MarketingTopicFromRawValue(marketingTopicRaw),
        )
      : isIntl2LwCohort
        ? isIntl2LwAdaptiveMarketingTopic(
            getIntl2LwMarketingTopicFromRawValue(marketingTopicRaw),
          )
        : isIntl2AdaptiveMarketingTopic(
            getIntl2MarketingTopicFromRawValue(marketingTopicRaw),
          )

  const geoDataResponse = await fetchGeoData()

  const attribution = {
    fbp,
    fbc,
    utmSource: searchParams.get('utm_source'),
    utmMedium: searchParams.get('utm_medium'),
    utmCampaign: searchParams.get('utm_campaign'),
    utmContent: searchParams.get('utm_content'),
    utmTerm: searchParams.get('utm_term'),
    geo: geoDataResponse
      ? {
          city: geoDataResponse.city,
          country: geoDataResponse.country,
          region: geoDataResponse.region,
          postalCode: geoDataResponse.postalCode,
          ip: geoDataResponse.ip,
          timezone: geoDataResponse.timezone,
        }
      : null,
  }

  const response = await subscriptionsApi.createLead({
    appName: APP_NAME,
    attribution,
    cohort: initialCohort,
    email: inputEmail || null,
    ...(isIntl2Cohort
      ? {
          extra: {
            marketingTopic,
            marketingTopicRaw,
            isAdaptiveMarketingTopic: isAdaptiveTopic,
          },
        }
      : {}),
    locale: language,
  })

  if (response && response.data) {
    const lead = response.data

    useZustandStore.setState({ lead })
    useZustandGlobalLocalStore.setState((state) => ({
      previousLeadId: state.previousLeadId || lead.id,
    }))

    // Redirect to the default page in case user started from another page
    goTo(`/?${searchParams.toString()}`)
  }

  useZustandStore.getState().stopProcessing(ProcessingKey.CREATE_LEAD)
}
